import { computed, Directive, effect, ElementRef, inject, Signal } from "@angular/core";
import { Store } from "@ngrx/store";
import { FromApp, RootState } from "src/app/store";
import * as FromAccountIdentifier from "src/app/store/accountidentifier/accountidentifier.selectors";
import { EventsStore } from "src/app/store/events/events.store";
import { AdminStore } from "src/app/store/admin-signal/admin.store";
import * as FromCoupon from "src/app/store/coupon/coupon.selectors";
import * as FromCustomer from "src/app/store/customer/customer.selectors";
import * as FromNewsfeed from "src/app/store/newsfeed/newsfeed.selectors";
import * as FromProgram from "src/app/store/program/program.selectors";
import { PushNotificationStore } from "src/app/store/pushnotification/pushnotification.store";
import * as FromToom from "src/app/store/toom/toom.selectors";
import * as FromTracking from "src/app/store/tracking/tracking.selectors";
import * as FromUser from "src/app/store/user/user.selectors";
import * as FromWebhook from "src/app/store/webhook/webhook.selectors";
import * as FromWorkflow from "src/app/store/workflow/workflow.selectors";

@Directive({ selector: "[appShowWhenLoading]" })
export class ShowWhenLoadingDirective {
  private readonly elementRef = inject(ElementRef);

  private readonly store = inject(Store<RootState>);

  private readonly adminStore = inject(AdminStore);
  private readonly eventsStore = inject(EventsStore);
  private readonly pushNotificationStore = inject(PushNotificationStore);

  private readonly appLoading: Signal<boolean> = this.store.selectSignal(FromApp.selectLoading);
  private readonly userLoading: Signal<boolean> = this.store.selectSignal(FromUser.selectLoading);
  private readonly toomLoading: Signal<boolean> = this.store.selectSignal(FromToom.selectLoading);
  private readonly couponLoading: Signal<boolean> = this.store.selectSignal(FromCoupon.selectLoading);
  private readonly webhookLoading: Signal<boolean> = this.store.selectSignal(FromWebhook.selectLoading);
  private readonly programLoading: Signal<boolean> = this.store.selectSignal(FromProgram.selectLoading);
  private readonly customerLoading: Signal<boolean> = this.store.selectSignal(FromCustomer.selectLoading);
  private readonly newsfeedLoading: Signal<boolean> = this.store.selectSignal(FromNewsfeed.selectLoading);
  private readonly trackingLoading: Signal<boolean> = this.store.selectSignal(FromTracking.selectLoading);
  private readonly workflowLoading: Signal<boolean> = this.store.selectSignal(FromWorkflow.selectLoading);
  private readonly accountIdentifierLoading: Signal<boolean> = this.store.selectSignal(FromAccountIdentifier.selectLoading);

  private readonly adminLoading: Signal<boolean> = this.adminStore.loading;
  private readonly eventLoading: Signal<boolean> = this.eventsStore.loading;
  private readonly pushNotificationLoading: Signal<boolean> = this.pushNotificationStore.loading;

  private readonly loading: Signal<boolean> = computed(
    () =>
      this.appLoading() ||
      this.accountIdentifierLoading() ||
      this.adminLoading() ||
      this.couponLoading() ||
      this.customerLoading() ||
      this.eventLoading() ||
      this.newsfeedLoading() ||
      this.programLoading() ||
      this.pushNotificationLoading() ||
      this.toomLoading() ||
      this.trackingLoading() ||
      this.userLoading() ||
      this.webhookLoading() ||
      this.workflowLoading(),
  );

  protected readonly loadingEffect = effect(() => {
    if (this.loading()) {
      (this.elementRef.nativeElement as HTMLElement).style.display = "block";
    } else {
      (this.elementRef.nativeElement as HTMLElement).style.display = "none";
    }
  });
}
